export default function getResource(label) {
    const resources = {
        savedForLaterTitle: 'Enregistré pour plus tard',
        viewAll: 'Tout afficher',
        remove: 'Retirer',
        moveToBasket: 'Déplacer dans le panier',
        moved: 'L’article a été déplacé',
        limitExceededTitle: 'Limite atteinte pour cet article',
        maxItemsReachedMessage: 'Nombre maximal d’articles enregistrés. Pour en ajouter d’autres, veuillez d’abord supprimer des produits.',
        ok: 'OK',
        genericErrorTitle: 'Erreur',
        genericErrorMessage: 'Une erreur s’est produite. Veuillez essayer de nouveau.',
        gotIt: 'Compris',
        itemShip: 'Désolé, cet article n’est pas offert dans votre pays.'
    };

    return resources[label];
}
